import script from "./UiElement.vue?vue&type=script&setup=true&lang=js"
export * from "./UiElement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__